<template>
  <el-button type="default" size="medium" @click.native="back">{{ $t('text.back') }}</el-button>
</template>
<script>
export default {
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
